import { Box, Container, Paper, useMediaQuery, useTheme } from "@mui/material";
import { Skeleton } from '@mui/material';
import CommentSectionSkeleton from "./CommentSectionSkeleton";

export const LibraryItemSkeleton = ({ commentsLoading }: { commentsLoading?: boolean }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const iconpx = 25;

  return <>
    <Container maxWidth="lg">
      <Skeleton variant="text" width={120} />
      <Skeleton variant="rectangular" width={200} style={{ margin: "8px auto 0px auto" }} />

      <Box display={"flex"} flexDirection={"row"} pt={1} alignItems={"center"}>
        {/* posters */}
        {!isMobile && (
          <Box className="spacing-y">
            {/* <Skeleton variant="rect" height={225} width={150} /> */}
            <Skeleton variant="rectangular" height={300} width={200} />
          </Box>
        )}

        {/* media section */}
        <Box
          //
          pl={isMobile ? 0 : 2.5}
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems={isMobile ? "center" : "unset"}
        >
          {/* title, updated_at */}
          <Skeleton variant="text" width={166} />
          <Box className="spacing" display={"flex"}>
            <Skeleton variant="text" width={50} />
            <Skeleton variant="text" width={50} />
            <Skeleton variant="text" width={50} />
          </Box>

          {/* watch, fav, list, subscribe button */}
          <Box
            className={isMobile ? "spacing-y" : "spacing"}
            display={"flex"}
            flexDirection={isMobile ? "column" : "row"}
            alignItems={"center"}
            pt={0.5}
          >
            <Box display={"flex"} className="spacing" flexDirection={"row"}>
              <Skeleton variant="circular" width={iconpx} height={iconpx} />
              <Skeleton variant="circular" width={iconpx} height={iconpx} />
              <Skeleton variant="circular" width={iconpx} height={iconpx} />
            </Box>
            <div>
              <Skeleton variant="rectangular" width={80} height={iconpx} style={{ borderRadius: 4 }} />
            </div>
          </Box>

          {/* Actors */}
          <Box display={"flex"} flexDirection={"row"} pt={2} pb={1} className="spacing">
            <Actor />
            <Actor />
          </Box>

          {/* series/movie details */}
          <Skeleton variant="text" width={200} height={30} />
          <Skeleton variant="rectangular" height={50} style={{ borderRadius: 4, maxWidth: 800, width: "100%" }} />
        </Box>
      </Box>
    </Container>

    {commentsLoading && <CommentSectionSkeleton />}

    {/* FilesTable */}
    <Paper>
      <Container maxWidth="md" style={{ backgroundColor: "#242323", borderRadius: 5 }}>
        <Skeleton
          variant="text"
          width={100}
          style={{ marginLeft: "auto", marginRight: "auto", paddingTop: 4, marginBottom: 2 }}
        />

        <div style={{ border: "#383838 solid 0.2px", borderRadius: 4 }}>
          <FileRow />
          <FileRow />
          <FileRow />
        </div>
      </Container>
    </Paper>
  </>;
};

const Actor = () => {
  const circlepx = 120;

  return (
    <Box display={"flex"} flexDirection="column" alignItems="center">
      <Skeleton variant="circular" height={circlepx} width={circlepx} />
      <Skeleton variant="text" width={80} />
      <Skeleton variant="text" width={70} />
    </Box>
  );
};

const FileRow = () => {
  return (
    <div style={{ display: "flex", borderBottom: "1px solid rgb(56, 56, 56)" }}>
      {/* file / age */}
      <div className="spacing" style={{ display: "flex", flex: 1, padding: "2px 0px 2px 16px" }}>
        <Skeleton variant="text" style={{ width: "100%", maxWidth: 200 }} />
        <Skeleton variant="text" style={{ width: "100%", maxWidth: 100 }} />
      </div>

      {/* 2 icons */}
      <div className="spacing" style={{ display: "flex", padding: "4px 16px 2px 8px" }}>
        <Skeleton variant="rectangular" width={18} height={18} style={{ borderRadius: 4 }} />
        <Skeleton variant="rectangular" width={18} height={18} style={{ borderRadius: 4 }} />
      </div>
    </div>
  );
};

export default LibraryItemSkeleton;
